/**
 * ストリーミングステータス
 */
export var StreamingStatuses;

(function (StreamingStatuses) {
  /**
   * 配信前
   */
  StreamingStatuses[StreamingStatuses["Offline"] = 0] = "Offline";
  /**
   * 配信中
   */

  StreamingStatuses[StreamingStatuses["Live"] = 1] = "Live";
  /**
   * アーカイブ配信中
   */

  StreamingStatuses[StreamingStatuses["Archive"] = 2] = "Archive";
})(StreamingStatuses || (StreamingStatuses = {}));